import React, { useState, useRef } from 'react';
//axios
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//bottomSheet
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'src/asset/scss/plugin/bottomsheet/style.scss';
import 'src/asset/scss/plugin/bottomsheet/bottomsheet.scss';
//fontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//style
import styles from 'src/asset/scss/style/user.mypage.module.scss'
//store
import useComnStore from 'src/webapp/stores/comn.store';
import usePartnerStore from 'src/webapp/stores/partner.store';
//comp
import Spinner from 'src/webapp/views/component/loading/Spinner';

export default function NoticeRegAndUpdate(props) {
    const { isOpen, data, boardList, setBoardList } = props;//props
	const { axiosPostHandler } = useAxiosHook();//axios
	const { setMessage } = useComnStore();//메세지결과처리
    const { partner } = usePartnerStore();

	const inputRef = useRef([]);
	/* =============== 버튼활성화여부 =============== */
	const [ isDisabled,setDisabled ] = useState(true);
	const onValidateHandler = () => {
		let disabled = false;
		for(let i = 0; i < inputRef.current.length; i++) {
			if(inputRef.current[i].value.length <= 0) { disabled = true; break; }
			if(data !== null) {
				if(inputRef.current[0].value === data.SUBJECT && inputRef.current[1].value === data.CONTENT) { disabled = true; break; }
			}
		}
		setDisabled(disabled);
	}
	/* =============== 버튼활성화여부 =============== */
    /* =============== 공지사항 등록,수정,삭제 API =============== */
	const [ isSubmit,setSubmit ] = useState(false);
	const onSubmitHandler = async(type) => {//type - 1.등록 or 수정, 2.삭제
		if(isSubmit || (type === 2 && !window.confirm("데이터 삭제 후 복구가 어려울 수 있습니다.\n해당데이터를 삭제하시겠습니까?"))) { return; }
		
		setSubmit(true);
        const DATA = { SEQ_NO:data !== null ? data.SEQ_NO : 0,  PARTNER_CD:partner.COMN_CD, SUBJECT:inputRef.current[0].value, CONTENT:inputRef.current[1].value, DEL_YN:type == 2 ? "Y" : "N" };
        const URL = data === null ? `partnerBoardRegForPartner.do` : `partnerBoardUpdateForPartner.do`;
        const result = await axiosPostHandler(URL, DATA);
		setTimeout(function() { setSubmit(false); }, 300);
        if(!result || result.message !== "SUCCESS") { return; }
        if(result.message === "SUCCESS") {
            let newList = [...boardList];
			if(type === 1) {
				const newData = {SEQ_NO:data === null ? result.data.result : data.SEQ_NO, SUBJECT:inputRef.current[0].value, CONTENT:inputRef.current[1].value};
				if(data === null) {
					newList = [newData, ...boardList];
				}
				if(data !== null) {
					newList = boardList.map((item) => item.SEQ_NO === data.SEQ_NO ? newData : item);
				}
				setMessage({type:1, message:`공지사항이 ${data === null ? '등록' : '수정'}되었습니다.`});
			}
			if(type === 2) {
				newList = boardList.filter(item => item.SEQ_NO !== data.SEQ_NO);
			}
            setBoardList(newList);
            props.onDismiss(false, null);
        }
	}
    /* =============== 공지사항 등록,수정,삭제 API =============== */

	return (
        <BottomSheet open={isOpen} onDismiss={(e) => props.onDismiss(false, null)}
            className={'bottomsheetContainer'}
            header={
				<>
				<button className={'bottomsheetDissmissButton'} onClick={(e) => props.onDismiss(false, null)}><FontAwesomeIcon icon="fa-light fa-xmark" /></button>
                <div style={{marginBottom:'3.75rem'}} className={'bottomsheetHeaderContainer'}>
					{data !== null ? <button className={'btnPrev'}></button> : null}
					<h1>공지사항 {data === null ? '등록하기' : '수정하기'}</h1>
					{data !== null ? <button onClick={(e) => onSubmitHandler(2)} className={'btnDelete'}>삭제</button> : null}
                </div>
				</>
            }
            footer={
				<div style={{marginTop:'3.75rem'}} className={styles.bottomsheetNoticeBtnArea}>
					<button onClick={(e) => onSubmitHandler(1)} disabled={isDisabled}>{!isSubmit ? '확인' : <Spinner />}</button>
                </div>
            }
			snapPoints={({ maxHeight }) => maxHeight}
            skipInitialTransition={false} scrollLocking={false} expandOnContentDrag={true}>
            <div className={styles.bottomsheetNoticeContainer}>
				<div>
					<label>제목입력</label>
					<input ref={el => (inputRef.current[0] = el)} 
						onChange={(e) => onValidateHandler()}
						type="text" defaultValue={data !== null ? data.SUBJECT : ''} 
						placeholder="제목을 입력해주세요" />
				</div>
				<div>
					<label>내용입력</label>
					<textarea ref={el => (inputRef.current[1] = el)} 
						onChange={(e) => onValidateHandler()}
						defaultValue={data !== null ? data.CONTENT : ''} 
						placeholder="내용을 입력해주세요" maxLength={300}></textarea>
					<small>최대 300자</small>
				</div>
			</div>
		</BottomSheet>
	)
}